import {WlDropdown} from "./dropdown.component";

export * from './dropdown.component';
export default WlDropdown;

customElements.define('wl-dropdown', WlDropdown);